import styles from './errorBlock.module.css';

export const ErrorBlock = ({ children, className = '' }) => {
    return (
        <div className={`${styles.errorBlock} ${className}`}>{children}</div>
    );
};
